import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import useIntroStore from 'hooks/useIntroStore'
import { useStaff } from 'hooks/useSession'
import { useSelectIntroDeal } from '@order/hooks/useDealTypeModal'
import useDealsByTags from '@order/hooks/useDealsByTags'

const TAG = 'tiles:sv'

export default function SingleVisionLargeSection() {
  const { t } = useTranslation(['ui', 'intro'])
  const text = 'intro:sections.singleVisionLarge'
  const badge = 'ui:badges.selfService'

  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { toggleMode } = useIntroStore()
  const staff = useStaff()

  const deals = useDealsByTags({
    hidden: true,
    requiredTags: [TAG],
  })

  const select = useSelectIntroDeal()

  const onPress = () => {
    const deal = deals.byTags[TAG]?.[0]

    if (deal) {
      select(deal)
      return
    }

    if (staff) {
      router.navigate('/staff/panel')
      return
    }
    toggleMode('staff', { redirect: '/staff/panel' })
  }

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          classNameDesc="w-2/3"
          badge={{ text: t(badge), variant: 'active' }}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="filled"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/lady-neon.png'),
            imageWrapperStyle: {
              width: '109%',
              height: '109%',
            },
            imageStyle: {
              transform: [{ translateX: -25 }, { translateY: 0 }],
            },
            blur: Platform.select({ default: 100, web: 25 }),
            blurStyle: {
              opacity: Platform.select({ default: 0.75, web: 0.5 }),
              transform: [
                { translateX: Platform.select({ default: -25, web: -10 }) },
                { translateY: 0 },
                { scale: Platform.select({ default: 1, web: 1.2 }) },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
